import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetOffersFromHistorySucceed, EGetOffersFromHistoryActionType } from './types';
import { IRecommendedOfferSchema } from '../../../repositories/search-engine/entities/recommended_offers/RecommendedOfferSchema';

export const getOffersFromHistorySucceed: (offers: IRecommendedOfferSchema[]) => TGetOffersFromHistorySucceed =
  actionGenerator<EGetOffersFromHistoryActionType.Succeed, IRecommendedOfferSchema[]>(
    EGetOffersFromHistoryActionType.Succeed,
  );
